<style lang="scss" src="./mdWhiteframe.scss"></style>

<script>
  import { h } from 'vue';

  export default {
    name: 'md-whiteframe',
    props: {
      mdElevation: {
        type: [String, Number],
        default: 1
      },
      mdComponent: Object,
      mdTag: {
        type: String,
        default: 'div'
      }
    },
    computed: {
      classes() {
        let numberedElevation = parseInt(this.mdElevation, 10);
        let elevationClass = 'md-whiteframe md-whiteframe-';

        if (!isNaN(numberedElevation) && typeof numberedElevation === 'number') {
          elevationClass += numberedElevation;
          elevationClass += 'dp';
        } else if (this.mdElevation.indexOf('dp') > -1) {
          elevationClass += this.mdElevation;
        }

        return elevationClass;
      }
    },
    render() {
      return h(this.mdComponent || this.mdTag || 'div', {
        class: this.classes,
      }, this.$slots);
    }
  };
</script>
